
interface Props {
  ok: boolean
  msg: string
}

export function FeedbackMessage({ ok, msg }: Props) {
  if (ok) {
    return (
      <div className="feedback-success" style={{ marginTop: 8, fontSize: '0.82rem', color: 'var(--green)' }}>
        {msg}
      </div>
    )
  }
  return (
    <div className="feedback-error" style={{ marginTop: 8, fontSize: '0.82rem', color: 'var(--red)' }}>
      {msg}
    </div>
  )
}
